export default {
  // Common words
  enter: "Zadat",
  next: "Další",
  previous: "Předchozí",
  finish: "Dokončit",
  returnToWebsite: "Zpět na web",
  complete: "Hotovo",
  submit: "Odeslat",
  cancel: "Zrušit",
  yes: "Ano",
  no: "Ne",
  skip: "Přeskočit",
  close: "Zavřít",
  discard: "Zahodit",
  save: "Uložit",
  "thank-you": "Děkujeme",
  select: "Vybrat",
  hi: "Ahoj",
  hello: "Dobrý den",
  link: "Odkaz",
  back: "Zpět",
  view: "Zobrazit",
  continue: "Pokračovat",
  of: "z",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Děkujeme, že jste si udělali čas, vaše zpětná vazba utváří naši nabídku <br /> do budoucna.",
  "client-survey-how-likely-recommend":
    "Jak pravděpodobné je, že byste nás doporučili ostatním?",
  "client-survey-how-likely-note":
    "Na stupnici 0–10, kde 0 znamená zcela nepravděpodobné a 10 velmi pravděpodobné.",
  "client-survey-how-likely-recommend-question":
    "Co jediného bychom mohli udělat, abyste nás s větší pravděpodobností doporučili?",
  "step-of": "Krok {step} z {total}",
  step: "Krok {step}",
  "client-survey-how-satisfied-with-service": "Jak jste spokojeni se službami",
  "client-survey-how-satisfied-with-service-question":
    "Co jediného bychom mohli udělat, abychom se zlepšili?",
  "client-survey-how-satisfied-with-food":
    "Jak jste spokojeni s jídlem, které od nás dostáváte?",
  "client-survey-how-satisfied-with-food-question":
    "Co jediného bychom mohli udělat, abychom se zlepšili?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Co je na spolupráci s námi nejlepší? Vyberte vše, co je pro vás důležité.",
  "management-team": "Manažerský tým",
  "the-front-line-operations-team": "Provozní tým v první linii",
  "food-offering": "Nabídka jídel",
  innovation: "Inovace",
  communication: "Komunikace",
  "flexibility-and-responsiveness": "Flexibilita a vstřícnost",
  billing: "Fakturace",
  "health-and-hygiene-standards": "Zdravotní a hygienické standardy",
  "if-other-please-specify": "Pokud jiné, upřesněte prosím...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Kde se na základě služeb, které poskytujeme, můžeme nejvíce zlepšit? Vyberte vše, co je pro vás důležité.",
  "please-can-we-have-some-more-detail":
    "Můžete nám prosím sdělit více podrobností?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Abychom porozuměli vašim prioritám v oblasti společenské odpovědnosti (CSR), seřaďte prosím následující podle důležitosti:",
  "sustainable-ingredients": "Udržitelné suroviny",
  "food-waste": "Plýtvání potravinami",
  "local-sourcing": "Lokální zdroje",
  "people-and-communities": "Lidé a komunity",
  "energy-reduction": "Snižování spotřeby energie",
  "working-with-local-communities": "Spolupráce s místními komunitami",
  "environmental-choices": "Ekologické volby",
  "meat-free": "Bez masa",
  "less-plastic": "Méně plastů",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Přejete si, abychom vás ohledně vaší zpětné vazby kontaktovali? Pokud ano, zanechte nám prosím níže své kontaktní údaje",
  "full-name": "Celé jméno",
  "email-address": "E-mailová adresa",
  "phone-number": "Telefonní číslo",
  feedback: "Zpětná vazba",
  "view-our-privacy-policy": "Zobrazit zásady ochrany osobních údajů",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Děkujeme, že jste si našli čas na vyplnění dotazníku!",

  // 404 Not Found
  "404-not-found": "404 Stránka nenalezena",

  // Privacy Policy
  "privacy-policy": "Zásady ochrany osobních údajů",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Rádi slyšíme, že se cítíte dobře. Prozradíte nám proč?",
  "employee-web-rating-feedback-step-1-negative":
    "Mrzí nás, že se necítíte nejlépe. Můžete nám prosím říct proč?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Chcete se s námi dnes podělit ještě o něco dalšího?",
  "employee-web-rating-feedback-step-2-information":
    "Máte nějaké připomínky nebo zpětnou vazbu k vaší dnešní zkušenosti s námi?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Podělte se s námi o svou dnešní zkušenost...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Chtěli byste někoho pochválit?",
  "no-employees-found": "Nebyli nalezeni žádní zaměstnanci",

  // Employee Web Rating Home
  "choose-location": "Vyberte pobočku",
  "search-location": "Hledat pobočku",
  "feedback-anonymous": "Chcete, aby vaše zpětná vazba zůstala anonymní?",
  "feedback-feeling-today": "Jak se dnes cítíte?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Děkujeme za vaši zpětnou vazbu!",
  "back-to-home": "Zpět na úvod",
  page: "Stránka",

  // Feedback Once Alert
  "feedback-once-alert":
    "Z této adresy URL již byla zpětná vazba jednou odeslána.",

  // Front Customer Audit
  "please-answer-above-question": "Odpovězte prosím na výše uvedenou otázku.",
  "add-comments": "Přidat komentář",
  "enter-answer": "Zadejte odpověď",
  "add-upload-files": "Přidat soubory k nahrání",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Koupili jste si dnes v lékárně lék?",
  "were-you-asked-any-of-the-following":
    "Zeptali se vás na některou z následujících otázek:",
  "who-is-the-medicine-for": "Pro koho je lék určen?",
  "what-are-your-symptoms": "Jaké máte příznaky?",
  "how-long-you-had-the-symptoms": "Jak dlouho příznaky máte?",
  "what-action-you-have-already-taken": "Jaká opatření jste již podnikli?",
  "are-you-taking-any-other-medication": "Užíváte nějaké další léky?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Čekali jste na obsloužení déle než 10 minut?",
  "were-the-products-you-wanted-in-stock":
    "Byly produkty, které jste chtěli, skladem?",
  "were-the-staff-friendly-and-helpful": "Byl personál přátelský a ochotný?",
  "did-you-receive-any-advice-about-your-medicines":
    "Dostali jste nějaké doporučení ohledně svých léků?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Jaká byla vaše dnešní zkušenost s námi?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Děkujeme za váš čas a vaše odpovědi.",
  "would-also-like-to-rate-us-on-google":
    "Chtěli byste nás také ohodnotit na Google?",
  "rate-us-now": "Ohodnoťte nás",

  // Negative Chat Reply
  "select-skill": "Vyberte dovednost",
  "none-selected": "Nic nevybráno",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Můžeme vás kontaktovat ohledně vaší dnešní zkušenosti?",
  "write-here": "Pište zde...",
  "please-can-we-get-your-name": "Můžete nám prosím sdělit své jméno?",
  "please-enter-your-email": "Zadejte prosím svůj e-mail:",
  "enter-your-phone-number": "Zadejte své telefonní číslo:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Řekněte nám prosím více o vaší zkušenosti:",
  "you-have-already-submitted-rating": "Hodnocení jste již odeslali",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Mrzí nás, že vaše dnešní zkušenost s námi nebyla nejlepší. Můžete nám prosím sdělit, co se pokazilo?",

  // Positive Chat Reply
  "select-employee": "Vyberte zaměstnance",
  "we-d-love-to-know-who-looked-after-you-today":
    "Rádi bychom věděli, kdo se o vás dnes staral?",
  "what-stood-out-to-you-today": "Co vás dnes zaujalo?",
  "did-we-provide-exceptional-service-today":
    "Poskytli jsme vám dnes výjimečné služby?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Máte nějaké připomínky nebo zpětnou vazbu k vaší dnešní zkušenosti s námi?",

  // Client Connect Director
  "message-from-leadership": "Zpráva od vedení",
  "message-from-leadership-text":
    "Neustále hledám způsoby, jak zlepšit naši nabídku pro naše klienty. Jsou podle vás oblasti, které bychom mohli zlepšit?",
  "client-connect-director-another-note":
    "A ještě něco — pokud existuje konkrétní téma, kterému by se náš tým měl věnovat, neváhejte se o něj podělit. Nejsem tu jen proto, abych naslouchal, ale abych na vaše připomínky a nápady reagoval.",
  "your-message-here": "Vaše zpráva zde",
  "visit-information": "Informace o návštěvě",
  "visit-time-out": "Čas odchodu",
  "contact-information": "Kontaktní údaje",
  "client-connect-director-contact-information-text":
    "Abychom vám mohli lépe pomoci, prosíme o vaše údaje — jméno, e-mailovou adresu a telefonní číslo. Díky nim vám budeme moci rychle odpovědět a kontaktovat vás.",
  name: "Jméno",
  "enter-your-name": "Zadejte své jméno",
  email: "E-mail",
  "enter-your-email": "Zadejte svůj e-mail",
  "contact-number": "Kontaktní číslo",
  "please-enter-your-name": "Zadejte prosím své jméno",
  "please-enter-your-email-or-phone-number":
    "Zadejte prosím svůj e-mail nebo telefonní číslo",
  "invalid-email-address": "Neplatná e-mailová adresa",
  "invalid-phone-number-format": "Neplatné telefonní číslo pro vybranou zemi.",
  "no-match-found": "Žádná shoda",
  "phone-number-must-be-digits-for-country":
    "Telefonní číslo musí mít {count} číslic pro vybranou zemi ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Telefonní číslo musí mít {min}–{max} číslic pro vybranou zemi ({current}/{max}).",
  "please-select-time": "Vyberte prosím čas",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Před odesláním dotazníku musíte uvést alespoň jednu odpověď.",

  // Mobile Survey Questions CheckBoxType
  comment: "Komentář",
  "comment-is-required": "Komentář je povinný!",
  "minimum-selection-is": "Minimální počet možností je {min_options}",
  "maximum-selection-is": "Maximální počet možností je {max_options}",
  "this-question-is-required": "Tato otázka je povinná!",
  "please-fill-all-required-grid-rows":
    "Vyplňte prosím všechny povinné řádky tabulky!",
  "please-fill-mandatory-fields-to-continue":
    "Pro pokračování vyplňte prosím povinná pole",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Vyberte prosím platné soubory obrázků.",

  // Mobile Survey Questions EmployeeType
  loading: "Načítání",
  "getting-employee": "Načítání zaměstnance...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Vyberte prosím platné soubory obrázků nebo videí.",
  "please-select-a-valid-file":
    "Vyberte prosím platný soubor (obrázek, video, PDF nebo Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Zadejte prosím číslo bez desetinných míst.",
  "please-enter-a-number-less-than-or-equal-to":
    "Zadejte prosím číslo menší nebo rovné {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Dokončete prosím svůj podpis.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address":
    "Zadejte prosím platnou e-mailovou adresu.",
  "phone-number-should-be-10-digit": "Telefonní číslo musí mít 10 číslic.",
  "please-enter-at-least-characters":
    "Zadejte prosím alespoň {minimum_character} znaků.",
  "select-date": "Vyberte datum",
  "select-time": "Vyberte čas",
  "client-connect-date-picker-aria": "Datum: {value}. Otevřít výběr data",
  "client-connect-time-picker-aria": "Čas: {value}. Otevřít výběr času",
  "select-country": "Vyberte zemi",

  // Report Page
  "click-the-link-to-see-how": "Klikněte na odkaz a zjistěte jak.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Že přidáním svých týmů do reportingové platformy ServeFirst se mohou také přihlásit a sledovat svůj výkon; navíc máte možnost spravovat svůj tým a přistupovat k dalším reportům, abyste porozuměli svému celkovému výkonu -",
  "did-you-know": "Víte, že..",
  count: "počet",
  average: "průměr",
  focus: "zaměření",
  performance: "Výkon",
  "you-can-create-bespoke-action-plans":
    "Můžete vytvářet akční plány na míru, které se propíší přímo sem, pokud je vytvoříte ve svém účtu ServeFirst. Zde můžete okamžitě vytvářet akce, harmonogramy a vlastníky a zároveň sledovat výkon. -",
  "no-of-times-raised": "Počet zmínění",
  action: "Akce",
  "attribute-name": "Název atributu",
  "action-plan": "Akční plán",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Že přidáním svých týmů do reportingové platformy ServeFirst se mohou také přihlásit a sledovat svůj výkon; navíc máte možnost spravovat svůj tým a přistupovat k dalším reportům, abyste porozuměli svému celkovému výkonu -",
  result: "Výsledek",
  category: "Kategorie",
  "your-location-vs-all-location": "Vaše pobočka vs. všechny pobočky",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Rozdělení odpovědí",
  "trended-net-promoter-score": "Vývoj Net Promoter Score",
  "trended-results": "Vývoj výsledků",
  "net-promoter-score-info":
    "Net Promoter Score vychází z % příznivců (hodnocení 5/5) minus % kritiků (hodnocení 1, 2 nebo 3). Více o Net Promoter Score se dozvíte kliknutím na následující",
  "customer-feedback": "Zpětná vazba zákazníků",
  logan: "Logan",
  "top-performer": "Nejlepší výkon",
  "rank-in-the-country": "Pořadí v zemi",
  "ytd-score": "Skóre od začátku roku",
  "score-during-period": "Skóre za období",
  "0-from-last-month": "0 oproti minulému měsíci",
  "total-responses-for-july-2021": "Celkový počet odpovědí za červenec 2021",
  promoter: "Příznivec",
  "from-04-sep-2021-to-06-sep-2021": "Od 04. 09. 2021 do 06. 09. 2021",
  "the-focus-currently-is-on": "Aktuální zaměření je na",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 zákazník to uvedl jako příležitost ke zlepšení.",
  "focus-for-the-month": "Zaměření na měsíc",
  "download-pdf": "Stáhnout PDF",

  // Report Page New Report
  "total-responses": "Celkem odpovědí",
  duration: "Období",
  "customers-have-stated-this-as-an-opportunity":
    "zákazníků to uvedlo jako příležitost ke zlepšení",
  "error-fetching-params": "Chyba při načítání parametrů!",
  "previous-days-was": "Předchozích {days} dní bylo {score}",

  // Report Page Common LgCard
  "raised-on": "# Zmíněno dne",
  results: "Výsledky",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Analyzujeme data, čekejte prosím...",

  // Report Page Components CustomerFeedBack
  "view-report": "Zobrazit report",
  "received-on": "Přijato dne",

  // Report Page Components ResponseBreakdown
  detractors: "Kritici",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Vývoj výsledků",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Nepodařilo se načíst soubor PDF",
  "error-generating-pdf-thumbnail": "Chyba při generování náhledu PDF",
  "error-in-thumbnail-generation-function":
    "Chyba ve funkci generování náhledu",
  "failed-to-generate-pdf-thumbnail": "Nepodařilo se vygenerovat náhled PDF",

  // Survey Pages Audition
  "select-audit": "Vyberte audit",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Vyberte alespoň {minOptions} možností",
  "select-max-options": "Maximálně {maxOptions} možností!",
  "error-saving-your-response": "Chyba při ukládání vaší odpovědi!",
  "failed-to-load-the-file": "Soubor se nepodařilo načíst!",
  "open-link": "Otevřít odkaz",
  download: "Stáhnout",
  details: "Podrobnosti",
  title: "Název",
  description: "Popis",
  "general-info": "Obecné informace",
  type: "Typ",
  size: "Velikost",
  "uploaded-by": "Nahrál(a)",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Děkujeme za váš čas!",

  // Survey Pages ClientConnect Content
  "review-content": "Prohlédnout obsah",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Dejte nám prosím zpětnou vazbu",
  "enter-your-response": "Zadejte svou odpověď",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Dobrý den, {name}",
  "client-connect-preview-sent-from": "Odesláno od {sender} - {date}",
  "client-connect-preview-step-of": "Krok {current} z {total}",
  "client-connect-preview-getting-started": "Začínáme",
  "client-connect-preview-getting-started-desc":
    "Prohlédněte si přehledové materiály, které jsme pro vás připravili.",
  "client-connect-preview-share-feedback": "Podělte se o zpětnou vazbu",
  "client-connect-preview-share-feedback-desc":
    "Vaše podněty nám pomáhají vytvářet pro vás lepší zkušenost.",
  "client-connect-preview-talk-leadership": "Promluvte si s vedením",
  "client-connect-preview-talk-leadership-desc":
    "Přečtěte si zprávu od vedení a uložte svou odpověď.",
  "client-connect-preview-reviewed-these": "Vše jsem si prohlédl(a)",
  "client-connect-preview-send-feedback": "Odeslat zpětnou vazbu",
  "client-connect-preview-finish-submit": "Dokončit a odeslat",
  "client-connect-preview-save-finish": "Dokončit a odeslat",
  "client-connect-preview-your-reply": "Vaše odpověď",
  "client-connect-preview-saved": "Uloženo",
  "client-connect-preview-edit": "Upravit",
  "client-connect-preview-pop-out": "Otevřít v novém okně",
  "client-connect-preview-open": "Otevřít",
  "client-connect-preview-view": "Zobrazit",
  "client-connect-preview-welcome": "Vítejte",
  "client-connect-preview-feedback": "Zpětná vazba",
  "client-connect-preview-save-message": "Odeslat zprávu",
  "client-connect-preview-message-footer": "Vaše zpráva půjde přímo vedení.",
  "client-connect-preview-leadership-placeholder": "Zadejte svou zprávu...",
  "client-connect-preview-thank-you": "Děkujeme",
  "client-connect-preview-thank-you-body":
    "Dokončili jste Client Connect. Vaše odpovědi z dotazníku a zpráva byly odeslány týmu — brzy se vám ozvou.",
  "client-connect-thank-you-message":
    "Děkujeme za váš čas. Vaše zpětná vazba má skutečný význam.",
  "client-connect-preview-review-answers": "Zkontrolovat mé odpovědi",
  "client-connect-preview-back-dashboard": "Zpět na přehled",
  "client-connect-preview-already-submitted":
    "Vaše zpětná vazba byla přijata. Děkujeme! Klidně si prohlédněte materiály výše.",
  "enter-email-address": "Zadejte e-mailovou adresu",
  "enter-phone-no": "Zadejte telefonní číslo",
  "product-type": "Typ produktu",
  "enter-number": "Zadejte číslo",
  aspect: "Aspekt",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Neustále hledám způsoby, jak zlepšit naši nabídku pro naše klienty. Jsou podle vás oblasti, které bychom mohli zlepšit?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "A ještě něco — pokud existuje konkrétní téma, kterému by se náš tým měl věnovat, neváhejte se o něj podělit. Nejsem tu jen proto, abych naslouchal, ale abych na vaše připomínky a nápady reagoval.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Abychom vám mohli lépe pomoci, prosíme o vaše údaje — jméno, e-mailovou adresu a telefonní číslo. Díky nim vám budeme moci rychle odpovědět a kontaktovat vás.",

  // Survey Pages Location
  "select-the-location-you-visited": "Vyberte pobočku, kterou jste navštívili",
  locations: "Pobočky",
  "is-this-your-current-location": "Je toto vaše aktuální pobočka?",
  "nearest-location": "Nejbližší pobočka",
  "loading-data": "Načítání dat...",
  "please-wait": "Čekejte prosím!",

  // Survey Pages Location Area
  "location-area": "Oblast pobočky",
  "select-location-area": "Vyberte oblast pobočky",

  // Survey Pages Login
  "please-enter-your-password": "Zadejte prosím své heslo",
  "value-must-be-longer-than-3-characters":
    "Hodnota musí být delší než 3 znaky",
  "please-enter-your-email-address": "Zadejte prosím svou e-mailovou adresu",
  password: "Heslo",
  "internal-server-error": "Interní chyba serveru!",
  "sign-in": "Přihlásit se",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey": "Tento dotazník jste již vyplnili!",
  "csat-link-invalid": "Tento odkaz na dotazník již není platný.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Vaše zpětná vazba byla odeslána. Číslo vašeho tiketu je #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Člen týmu se vám brzy ozve.",
  "would-you-also-like-to-rate-us-on-google":
    "Chtěli byste nás také ohodnotit na Google?",
  "to-review-our-terms-and-conditions-please-click":
    "Pro zobrazení našich obchodních podmínek klikněte",
  here: "Zde",
  "ticket-number-copied-to-clipboard": "Číslo tiketu zkopírováno do schránky",

  // Survey Pages Welcome
  "visit-date": "Datum návštěvy",
  "visit-time-in": "Čas příchodu",
  "please-select-date": "Vyberte prosím datum",
  "guest-info": "Informace o hostovi",
  "please-select-user": "Vyberte prosím uživatele",
  "get-started": "Začít",

  // Survey Pages InventoryType
  "enter-value": "Zadejte hodnotu",
  "getting-product-list": "Načítání seznamu produktů...",

  // Survey Pages NotesAndImage
  "upload-file": "Nahrát soubor",

  // Survey Pages NumberType
  "enter-digit": "Zadejte číslici",

  // Survey Pages TextArea
  "enter-your-comment": "Zadejte svůj komentář",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Velikost souboru musí být menší než 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Přetáhněte sem své soubory (velikost menší než 10 MB) nebo",
  "upload-or-drag-and-drop-your-files-here":
    "Nahrajte nebo přetáhněte své soubory sem",
  "browse-files": "Procházet soubory",

  // Survey Pages Questions
  "next-question": "Další otázka",
  "save-and-exit": "Uložit a ukončit",
  "failed-to-save-and-exit":
    "Váš postup se nepodařilo uložit. Zkuste to prosím znovu.",
  "progress-saved-you-may-close-this-tab":
    "Váš postup byl uložen. Nyní můžete tuto kartu prohlížeče zavřít.",
  "please-enter-at-least": "Zadejte prosím alespoň {min} znaků.",
  "contact-no": "Kontaktní číslo",
  "please-select-location": "Vyberte prosím pobočku!",
  "please-select-survey": "Vyberte prosím dotazník!",
  "please-enter-your-email-address-or-phone-number":
    "Zadejte prosím svou e-mailovou adresu nebo telefonní číslo.",

  // Utils CompressFiles
  "compression-error": "Chyba komprese:",

  // Web Rating FrontLogin
  "enter-location-id": "Zadejte ID pobočky",
  "invalid-location-id": "Neplatné ID pobočky",
  "location-id-required": "ID pobočky je povinné",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Řekněte nám prosím, jaká byla vaše dnešní zkušenost.",

  // Web Rating Negativefeedback
  "enter-valid-email-address": "Zadejte platnou e-mailovou adresu.",
  "can-we-get-in-touch-with-you": "Můžeme vás kontaktovat?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Zadejte své telefonní číslo",
  "write-your-feedback": "Napište svou zpětnou vazbu",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Čím vás {employeeName} zaujal(a)?",
  team: "Tým",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Vraťte se prosím na předchozí krok a vyberte zaměstnance. Bez výběru zaměstnance nelze formulář zpětné vazby odeslat",
  "share-us-your-experience-with-us-today":
    "Podělte se s námi o svou dnešní zkušenost...",
  "did-employee-name-provide-exceptional-service":
    "Poskytl(a) vám {employeeName} výjimečné služby?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Vynikl(a) {employeeName} poskytnutím výjimečných služeb?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Zadejte prosím uživatelské jméno",
  "please-enter-password": "Zadejte prosím heslo",

  // Web Rating New RatingLocations
  search: "Hledat",
  "select-loction-to-ratings": "Vyberte pobočku pro hodnocení",
  location: "Pobočka",
  "is-this-your-location": "Je toto vaše pobočka?",
  "fetch-details-failed": "Načtení údajů se nezdařilo",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Klikněte na libovolný počet možností",
  "what-made-employee-name-stand-out-to-you":
    "Čím vás {employeeName} zaujal(a)?",
  "what-made-the-team-stand-out-to-you": "Čím vás zaujal náš tým?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Vynikli jsme poskytnutím výjimečných služeb?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Zanechte e-mail nebo telefonní číslo, pokud chcete, abychom vás kontaktovali. Jinak pole nechte prázdné a stiskněte Další",
  "anything-else-you-d-like-to-share":
    "Chcete se podělit ještě o něco dalšího?",
  "enter-valid-email": "Zadejte platný e-mail",
  message: "Zpráva",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Odesláním formuláře souhlasíte s našimi podmínkami a zásadami ochrany osobních údajů.",

  // Web Rating New FrontWebLogin
  login: "Přihlásit se",
  username: "Uživatelské jméno",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Stiskněte výraz obličeje, který nejlépe vystihuje, jak hodnotíte svou zkušenost.",
  "getting-employee-list": "Načítání seznamu zaměstnanců",
  "getting-skill-data": "Načítání dat dovedností",
  "getting-screen-saver": "Načítání spořiče obrazovky",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Děkujeme, že jste nás kontaktovali.",
  "we-ll-be-in-touch-very-soon": "Velmi brzy se vám ozveme.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Pomocí tohoto tlačítka nás můžete ohodnotit na Google",
  "rate-us-on-google": "Ohodnoťte nás na Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Kontaktujte nás",
  "or-you-may-reach-us-on": "...nebo nás můžete zastihnout na.",
  "do-you-want-to-learn-more-about-serve-first":
    "Chcete se o Serve First dozvědět více?",

  // Web Rating New CommonComponents BottomBar
  saving: "Ukládání",
  "please-enter-only-digits-for": "Zadejte prosím pouze číslice pro",
  "please-enter": "Zadejte prosím",
  "enter-value-here": "Zadejte hodnotu zde",

  // Survey Pages Questions Dropdown
  "please-select": "Vyberte prosím",
  "survey-retry-message":
    "Tento dotazník budete moci vyplnit znovu za {value} {unit}.",
  minute: "minutu",
  minutes: "minut",
  hour: "hodinu",
  hours: "hodin",
  day: "den",
  days: "dní",
  week: "týden",
  weeks: "týdnů",
  month: "měsíc",
  months: "měsíců",
  clear: "Vymazat",

  "powered-by": "Provozuje",
  "image-is-required": "Obrázek je povinný",
  "please-fill-all-required-contact-information":
    "Vyplňte prosím všechny povinné kontaktní údaje",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Jakoukoli další zpětnou vazbu prosím napište do pole níže.",
  "all-feedback-is-confidential": "Veškerá zpětná vazba je důvěrná",
  "your-feedback-has-been-received-thank-you":
    "Vaše zpětná vazba byla přijata, děkujeme",
  "close-page": "Zavřít stránku",
  send: "Odeslat",
  sending: "Odesílání",
  "enter-your-feedback-here": "Zadejte zde svou zpětnou vazbu",
  "for-anything-else-please": "S čímkoli dalším se prosím obraťte ",
  "please-correct-the-custom-field-values":
    "Opravte prosím hodnoty vlastních polí",
  "please-complete-all-required-contact-information":
    "Vyplňte prosím všechny povinné kontaktní údaje",
  "survey-cannot-be-submitted": "Dotazník nelze odeslat",
  "please-enter-your-phone": "Zadejte prosím svůj telefon",
  "network-error-please-try-again":
    "Chyba sítě. Zkontrolujte prosím připojení a zkuste to znovu.",
  "no-results-found": "Nebyly nalezeny žádné výsledky",
  "drop-files-here": "Přetáhněte soubory sem...",
  "drag-drop-files": "Přetáhněte sem soubory, nebo klikněte pro výběr",
  "max-5-files-5mb": "Max. 5 souborů, každý do 5 MB, pouze obrázky",
  remove: "Odebrat",

  // Learning & Development

  "ld-module-title": "Vzdělávání a rozvoj",
  "ld-no-sign-in-required": "Není nutné přihlášení",
  "ld-progress-warning":
    "Nezavírejte prosím toto okno — váš postup se neukládá a museli byste začít znovu.",
  "ld-loading-module": "Načítání vzdělávacího modulu…",
  "ld-unable-load-module": "Vzdělávací modul se nepodařilo načíst.",
  "ld-package-not-configured": "Vzdělávací balíček není nakonfigurován.",
  "ld-start-guidance": "Začít školení",
  "ld-due-date": "Termín: {date}",
  "ld-whats-involved": "Co vás čeká",
  "ld-your-progress": "VÁŠ POSTUP",
  "ld-step-of": "Krok {current} z {total}",
  "ld-watched-in-full": "Zhlédnuto celé",
  "ld-video-no-skip": "Můžete se vracet, ale ne přeskakovat dopředu",
  "ld-video-muted-counts": "Ztlumeno — přehrávání se stále započítává",
  "ld-maximize-document": "Maximalizovat dokument",
  "ld-minimize-document": "Minimalizovat dokument",
  "ld-read-percent": "Přečteno {percent} %",
  "ld-end-of-document": "Konec dokumentu",
  "ld-scroll-to-continue": "Pro pokračování posouvejte dolů",
  "ld-read-to-end": "Přečtěte až do konce",
  "ld-read-to-end-to-continue": "Pro pokračování přečtěte až do konce",
  "ld-loading-document": "Načítání dokumentu…",
  "ld-pdf-preview-unavailable":
    "Náhled tohoto PDF nelze v prohlížeči zobrazit.",
  "ld-pdf-page-alt": "{title} — strana {page}",
  "ld-knowledge-check": "OVĚŘENÍ ZNALOSTÍ",
  "ld-knowledge-check-title": "{title} — ověření znalostí",
  "ld-quiz-instruction":
    "Odpovězte na {count, plural, one {# otázku} few {# otázky} other {# otázek}}. Hranice úspěšnosti {passMark} %.",
  "ld-quiz-instruction-pass-only": "Hranice úspěšnosti {passMark} %.",
  "ld-question-of": "OTÁZKA {current} Z {total}",
  "ld-guidance-of": "ŠKOLENÍ {current} Z {total}",
  "ld-loading-questionnaire": "Načítání dotazníku…",
  "ld-preparing-questions": "Připravujeme vaše otázky",
  "ld-submit-answers": "Odeslat odpovědi",
  "ld-submitting": "Odesílání…",
  "ld-ready-to-submit": "Připraveno k odeslání odpovědí",
  "ld-answer-selected": "Odpověď vybrána",
  "ld-select-answer": "Pro pokračování vyberte jednu odpověď",
  "ld-pass-mark-note":
    "K úspěšnému absolvování potřebujete {passMark} % nebo více. Odeslané odpovědi již nelze změnit.",
  "ld-questionnaire-not-configured": "Dotazník není nakonfigurován.",
  "ld-unable-load-questionnaire": "Dotazník se nepodařilo načíst.",
  "ld-no-visible-questions":
    "Pro toto ověření znalostí nejsou momentálně k dispozici žádné otázky.",
  "ld-unable-submit-answers":
    "Odpovědi se nepodařilo odeslat. Zkuste to prosím znovu.",
  "ld-not-passed": "Neúspěšné",
  "ld-completed": "Dokončeno",
  "ld-fail-title": "Těsně vedle — zkuste to znovu",
  "ld-fail-description":
    "Dosáhli jste {score} — hranice úspěšnosti je {passMark} %. Zbývá vám {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# pokus} few {# pokusy} other {# pokusů}}",
  "ld-attempt-of": "Pokus {current} z {total}",
  "ld-fail-alert":
    "Projděte si prosím znovu výukové materiály a poté ověření zopakujte. Po posledním pokusu se ověření uzamkne.",
  "ld-try-again": "Zkusit znovu",
  "ld-review-guidance": "Projít výuku znovu",
  "ld-locked-title": "Toto školení je nyní uzamčeno",
  "ld-locked-description":
    "Dosáhli jste {score} — hranice úspěšnosti pro tento balíček je {passMark} %. Z důvodu dodržování předpisů jej zde nemůžete opakovat.",
  "ld-speak-to-manager": "Obraťte se na svého vedoucího",
  "ld-locked-manager-copy":
    "Váš vedoucí směny může {courseTitle} znovu vydat, abyste si mohli výuku projít znovu a ověření zopakovat.",
  "ld-close-window": "Nyní můžete toto okno zavřít.",
  "ld-close-window-safe": "Nyní můžete toto okno bezpečně zavřít.",
  "ld-success-title": "Gratulujeme!",
  "ld-success-description":
    "Úspěšně jste dokončili {courseTitle}. Bylo to zaznamenáno do vašeho vzdělávacího profilu — nic dalšího už dělat nemusíte.",
  "ld-email-yourself": "Poslat si kopii e-mailem",
  "ld-email-copy-description":
    "Nechte si zaslat potvrzení o dokončení do své schránky pro vlastní evidenci.",
  "ld-email-placeholder": "vy@spolecnost.cz",
  "ld-sent": "Odesláno",
  "ld-sending-email": "Odesílání…",
  "ld-unable-send-email":
    "E-mail se nepodařilo odeslat. Zkuste to prosím znovu.",
  "ld-email-sent-success": "Potvrzovací e-mail byl úspěšně odeslán!",
  "ld-video-briefing": "Videoškolení",
  "ld-document": "Dokument",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · bez přeskakování",
  "ld-document-meta": "Dokument · PDF",
  "ld-document-meta-scroll": "Dokument · PDF · posunout na konec",
  "ld-video-instruction-full": "Zhlédněte celé — nelze přeskakovat dopředu",
  "ld-video-instruction": "Zhlédněte školení a poté pokračujte",
  "ld-document-instruction-scroll": "Pro pokračování posuňte na konec",
  "ld-document-instruction": "Projděte si dokument a poté pokračujte",
  "ld-questionnaire": "Dotazník",
  "ld-confirmation": "Potvrzení",
  "ld-question-count":
    "{count, plural, one {# otázka} few {# otázky} other {# otázek}}",
  "ld-knowledge-check-subtitle": "Ověření znalostí",
  "ld-score": "Skóre",
  "ld-whats-involved-pass-mark":
    "Hranice úspěšnosti {passMark} % · odemkne se po dokončení výuky",
  "ld-document-type-pdf": "{documentType} · PDF",
};
